import { SECOND } from '../utils';

export const SELFIE_INTERVAL = 5 * SECOND;
export const GROUP_PHOTO_INTERVAL = 10 * SECOND;
